import React, { useState, useEffect } from 'react';
import { create } from 'zustand';
import { getExerciseLogsForUsers } from 'src/queries/exercise';

export const useExercise = create((set, get) => {
  return {
    logs: [],
    loadingLogs: true,
    setLogs: (newLogs) => {
      return set({ logs: newLogs });
    },
    mostRecentLogs: [],
    setMostRecentLogs: (newLogs) => {
      return set({ mostRecentLogs: newLogs });
    },
    getExerciseLogsForUsers: (appUsers) => {
      const { getMostRecentLogsByUser } = get();
      set({ loadingLogs: true });
      getExerciseLogsForUsers(appUsers, (logs) => {
        getMostRecentLogsByUser(appUsers, logs);
        return set({ loadingLogs: false, logs });
      });
    },
    getMostRecentLogsByUser: (appUsers, logs) => {
      const recentLogs = appUsers.map((user) => {
        const userLogs = [...logs].filter((log) => log.username === user.username);
        const mostRecentLog = userLogs.reduce((prev, current) => {
          if (!prev || current.dateAndTimeSubmitted > prev.dateAndTimeSubmitted) {
            return current;
          }
          return prev;
        }, null);

        return mostRecentLog;
      });
      return set({ mostRecentLogs: recentLogs });
    },
  };
});
